<template>
    <div class="relative inline-flex">
        <button @click="toggleDropdown" type="button" class="nl-btn-primary !h-14 !px-6" :aria-expanded="showDropdown">
            <span class="icon-play"></span> Smart play
            <span class="icon-chevron-down text-xs transition-transform" :class="{ 'rotate-180': showDropdown }"></span>
        </button>
        <transition enter-active-class="transition ease-out duration-150" enter-from-class="transform opacity-0 -translate-y-1 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-100" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
            <ul v-if="showDropdown" class="absolute left-0 top-full z-50 mt-2 w-56 origin-top-left rounded-lg bg-nomad-800 p-1 shadow-lift">
                <li><button type="button" @click="prepareCurrent({ id: song.id, type: 'SONG', name: song.name || song.title }); showDropdown = false"
                        class="flex w-full items-center gap-3 rounded-md px-3 py-2.5 text-left text-sm text-white transition-colors hover:bg-white/[0.06]">
                        <span class="flex h-8 w-8 items-center justify-center rounded-full bg-nomad-accent text-black"><span class="icon-play translate-x-px"></span></span>
                        Full song</button></li>
                <li><button type="button" @click="prepareCurrent({ id: song.id, type: 'SONG', name: song.name || song.title, stream: 'VOCAL' }); showDropdown = false"
                        class="flex w-full items-center gap-3 rounded-md px-3 py-2.5 text-left text-sm text-white transition-colors hover:bg-white/[0.06]">
                        <span class="flex h-8 w-8 items-center justify-center rounded-full bg-white/10 text-nomad-accent"><span class="icon-mic"></span></span>
                        Vocals only</button></li>
                <li><button type="button" @click="prepareCurrent({ id: song.id, type: 'SONG', name: song.name || song.title, stream: 'MUSIC' }); showDropdown = false"
                        class="flex w-full items-center gap-3 rounded-md px-3 py-2.5 text-left text-sm text-white transition-colors hover:bg-white/[0.06]">
                        <span class="flex h-8 w-8 items-center justify-center rounded-full bg-white/10 text-nomad-accent"><span class="icon-music"></span></span>
                        Music only</button></li>
            </ul>
        </transition>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
    props:{
        song: {
            type:Object
        }
    },
    data() {
        return {
            showDropdown: false,
        };
    },
    methods: {
        ...mapActions("current", ["prepareCurrent"]),
        toggleDropdown() {
            this.showDropdown = !this.showDropdown;
        },
        hideDropdown(event) {
            if (!this.$el.contains(event.target)) {
                this.showDropdown = false;
            }
        },
    },
    mounted() {
        document.addEventListener('click', this.hideDropdown);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.hideDropdown);
    },
}
</script>